import React from "react";
import { view } from "../../lib/vvm";
import { EmptyImage } from "../EmptyImage/EmptyImage";
import styles from "./ProductPhotoSlider.module.css";
import {
  ProductPhotoSliderViewModel,
  type ProductPhotoSliderProps,
} from "./ProductPhotoSliderViewModel";

export const ProductPhotoSlider: React.FC<ProductPhotoSliderProps> = view(
  ProductPhotoSliderViewModel,
)<ProductPhotoSliderProps>(({ viewModel }) => {
  const {
    alt,
    className,
    trackClassName,
    imageClassName,
    emptyClassName,
    photos,
    hasPhotos,
    hasManyPhotos,
    activeDotIndex,
    shouldUseEagerLoading,
    setTrackNode,
    onTrackScroll,
  } = viewModel;

  if (!hasPhotos) {
    return (
      <div className={`${styles.root} ${className || ""}`.trim()}>
        <div
          className={`${styles.empty} ${emptyClassName || ""}`.trim()}
          aria-label="Изображение отсутствует"
        >
          <EmptyImage />
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.root} ${className || ""}`.trim()}>
      <div
        ref={setTrackNode}
        className={`${styles.track} ${trackClassName || ""}`.trim()}
        onScroll={onTrackScroll}
      >
        {photos.map((photo, index) => (
          <figure key={`${photo}-${index}`} className={styles.slide}>
            <img
              src={photo}
              alt={alt}
              className={`${styles.image} ${imageClassName || ""}`.trim()}
              loading={index === 0 && shouldUseEagerLoading ? "eager" : "lazy"}
              decoding="async"
            />
          </figure>
        ))}
      </div>

      {hasManyPhotos && (
        <div className={styles.dots} aria-hidden={true}>
          {photos.map((_photo, index) => (
            <span
              key={index}
              data-slider-dot=""
              data-active={index === activeDotIndex ? "true" : "false"}
              className={`${styles.dot} ${
                index === activeDotIndex ? styles.dotActive : ""
              }`.trim()}
            />
          ))}
        </div>
      )}
    </div>
  );
});
